import { QueryClient } from '@tanstack/react-query';

// Singleton QueryClient instance for the entire app
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 60_000,
    },
    mutations: {
      retry: 0,
    },
  },
});


